import React, { createContext, useContext } from 'react'
import type { EmployeeComplianceSummary } from '../types/compliance'

export interface EmployeeComplianceContextValue {
  employeeId: number
  compliance: EmployeeComplianceSummary | null
  employeeStatus?: 'active' | 'dismissed' | 'maternity'
  onRefresh: () => void
}

const EmployeeComplianceContext = createContext<EmployeeComplianceContextValue | null>(null)

export function EmployeeComplianceProvider({
  value,
  children,
}: {
  value: EmployeeComplianceContextValue | null
  children: React.ReactNode
}) {
  return <EmployeeComplianceContext.Provider value={value}>{children}</EmployeeComplianceContext.Provider>
}

export function useEmployeeCompliance(): EmployeeComplianceContextValue | null {
  return useContext(EmployeeComplianceContext)
}
